<div
    *transloco="let t; prefix: 'uiArc'"
    class="relative">
    <svg
        viewBox="0 0 236 130"
        class="w-[236px] h-[130px]">
        <path
            #backgroundArc
            class="background-arc fill-none stroke-primary-100 dark:stroke-primary stroke-[12px] [stroke-linecap:round]"
            id="fullArc" />

        <path
            #progressArc
            class="progress-arc fill-none stroke-primary dark:stroke-primary-50 stroke-[12px] [stroke-linecap:round]"
            id="progressArc" />
    </svg>
    <div class="absolute w-4/5 text-center transform -translate-x-1/2 top-10 left-1/2">
        <div class="text-primary dark:text-primary-50 font-ci leading-none mb-2">
            <span class="text-[56px]">{{ current() }}</span>
            {{ t('outOf', { value: total() }) }}
        </div>
        <span class="text-sm font-semibold">{{ label() }}</span>
    </div>
</div>
